module.exports = "/_next/static/images/img__book-91c8e48d41f206df074e335419a143f6.png";